import { ms_applicant_alevel } from "@v2/validators";
import { Field, Form, Formik } from "formik";
import React from "react";
import ErrorMessage from "../../components/ErrorMessage";
import swal from "../../helpers/swal";
import { axiospost } from "../../helpers/httprequest";
import { useQueryClient } from "@tanstack/react-query";

const Diploma = ({ data, setdata }) => {
  const queryClient = useQueryClient(); // Access the Query Client

  const _save = async (values) => {
    try {
      const req = await axiospost("ms_applicant_alevel", {
        type: "Diploma",
        results: values,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data: result } = req;
      if (result && result.type === "success") {
        const { message, type } = result;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["aLevelResult"] });
      } else {
        throw new Error(result.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };
  return (
    <Formik
      initialValues={{
        institutionName: data ? data?.institutionName : "",
        yearOfGraduation: data ? data?.yearOfGraduation : "",
        courseOfStudy: data ? data?.courseOfStudy : "",
        classification: data ? data?.classification : "",
        diplomaType: data ? data?.diplomaType : "",
        cgpa: data ? data?.cgpa : "",
      }}
      validationSchema={ms_applicant_alevel.Diploma}
      initialTouched={{ zip: true }}
      onSubmit={_save}
    >
      {({ isSubmitting, touched, errors }) => (
        <Form className="row">
          <div className="col-md-6">
            <ErrorMessage
              name={"institutionName"}
              label="Name of Institution"
              type="text"
              key={`error_institutionName`}
              errors={errors?.institutionName}
              touched={touched?.institutionName}
            />
          </div>
          <div className="col-md-6">
            <ErrorMessage
              name={"courseOfStudy"}
              label="Course of Study"
              type="text"
              key={`error_courseOfStudy`}
              errors={errors?.courseOfStudy}
              touched={touched?.courseOfStudy}
            />
          </div>

          <div className="col-md-6">
            <div className="form-group form-floating">
              <Field
                as="select"
                name="classification"
                id="classification"
                errors={errors?.classification}
                className={`form-control form-control-lg ${errors?.classification && "is-invalid"}`}
              >
                <option value="">Select Option</option>
                <option value="First Class">First Class</option>
                <option value="Second Class Upper">Second Class Upper</option>
                <option value="Second Class Lower">Second Class Lower</option>
                <option value="Third Class">Third Class</option>
                <option value="Pass">Pass</option>
              </Field>
              <label htmlFor="classification">Select Classification of Degree</label>
              {errors?.classification && touched?.classification ? (
                <div className="text-danger mt-1 p-1 text-small">{errors?.classification}</div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group form-floating">
              <Field
                as="select"
                name="diplomaType"
                errors={errors?.diplomaType}
                className={`form-control form-control-lg ${errors?.diplomaType && "is-invalid"}`}
              >
                <option value="">Select Option</option>
                <option value="National Diploma">National Diploma</option>
                <option value="Advance National Diploma">Advance National Diploma</option>
              </Field>
              <label htmlFor="firstname">Select diploma type of Degree</label>
              {errors?.diplomaType && touched?.diplomaType ? <div className="text-danger mt-1 p-1 text-small">{errors?.diplomaType}</div> : null}
            </div>
          </div>
          <div className="col-md-6">
            <ErrorMessage name={"cgpa"} label="CGPA" type="text" key={`error_cgpa`} errors={errors?.cgpa} touched={touched?.cgpa} />
          </div>
          <div className="col-md-6">
            <ErrorMessage
              name={"yearOfGraduation"}
              label="Year of Graduation"
              type="text"
              key={`error_yearOfGraduation`}
              errors={errors?.yearOfGraduation}
              touched={touched?.yearOfGraduation}
            />
          </div>
          <div className="col-md-12">
            <button disabled={isSubmitting} type="submit" className="btn btn-primary btn-block btn-lg">
              {isSubmitting ? "Please wait ..." : "Save changes"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Diploma;
